import * as React from 'react'

import { type SelectOption } from '@factorialco/deprecated-design-system'
import moment from 'moment'
import { RRule } from 'rrule'

import { observer } from 'mobx-react'

import SelectField from 'modules/core/components/SelectField'
import i18n from 'modules/core/lib/i18n'

import enableDay from 'modules/payroll_bundle/lib/enableDay'
import StartsOnDatePicker from 'modules/payroll_bundle/pages/SelfServicePage/components/payrollPolicyStep/StartOnDateSelector'
import Policy, { PeriodicityType } from 'modules/payroll_bundle/store/models/Policy'

import type { RecurrenceType } from '../../types'

interface periodicityChangeType {
  periodicity: PeriodicityType
  starts_on: string
  recurrence: RecurrenceType
}

interface Props {
  onChangeStartDate: (value: string) => void
  onChangePeriodicity: (value: periodicityChangeType) => void
  periodicityValue: string
  startOnValue: string
}

const PeriodicitySelector = ({
  onChangeStartDate,
  onChangePeriodicity,
  periodicityValue,
  startOnValue,
}: Props) => {
  const periodicities = Policy.periodicities()

  const periodicityOptions: SelectOption[] = Object.keys(periodicities).map((key) => ({
    label: periodicities[key as PeriodicityType].label ?? '',
    value: key,
  }))

  const enableDayForPolicy = (day: Date | moment.Moment): boolean => {
    const momentDay = moment(day)
    const recurrence = periodicities[periodicityValue as PeriodicityType].recurrence

    return enableDay({ day: momentDay, recurrence })
  }

  const startDateByPeriodicity = (periodicity: string): moment.Moment => {
    const options = RRule.parseString(
      periodicities[periodicity as PeriodicityType].recurrence ?? ''
    )
    options.dtstart = new Date(Date.UTC(2000, 1, 1))

    const rule = new RRule(options)
    const day = new Date()
    const firstDayInUTC = new Date(Date.UTC(day.getFullYear(), day.getMonth(), 1))
    const lastDayInUTC = new Date(Date.UTC(day.getFullYear(), day.getMonth() + 1, 0))

    return moment(rule.between(firstDayInUTC, lastDayInUTC, true)[0])
  }

  const handlePeriodicity = (value: PeriodicityType): void => {
    const startsOn = startDateByPeriodicity(value)

    onChangePeriodicity({
      recurrence: periodicities[value as PeriodicityType].recurrence as RecurrenceType,
      periodicity: value,
      starts_on: startsOn.format('YYYY-MM-DD'),
    })
  }

  return (
    <>
      <SelectField
        label={i18n.t('payroll_bundle.onboarding.payroll_policy_step.periodicity_selector')}
        onChange={(value) => handlePeriodicity(value as PeriodicityType)}
        value={periodicityValue}
        options={periodicityOptions}
      />

      <StartsOnDatePicker
        startOnValue={startOnValue}
        label={i18n.t('payroll_bundle.onboarding.payroll_policy_step.starts_on_selector')}
        enableDay={enableDayForPolicy}
        periodicity={periodicityValue}
        onChange={onChangeStartDate}
      />
    </>
  )
}

export default observer(PeriodicitySelector)
